<template>
  <el-carousel class="banner" height="330px">
    <template v-for="(item, index) in list">
      <el-carousel-item :key="index" v-if="item.adType === 1">
        <a :href="item.redirectUrl" target="_blank">
          <img :src="`${item.adUrl}?imageView2/1/w/770/h/330`" />
        </a>
      </el-carousel-item>
    </template>
  </el-carousel>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      list: [],
    };
  },
  computed: mapState({
    portalDomain: state => state.app.portalDomain,
  }),
  watch: {
    $route() {
      const id = this.portalDomain.enterpriseId;
      const { channelId } = this.$route.query;
      const arg = {
        open_req_src: 'qysc_yyn',
        enterprise_id: id,
      };
      if (channelId) {
        arg.chaneel_id = channelId;
      } else {
        arg.chaneel_id = 0;
      }
      this.$store.dispatch('app/getQyscAdvList', arg).then((data) => {
        this.list = data;
      });
    },
  },
  created() {
    const id = this.portalDomain.enterpriseId;
    const { channelId } = this.$route.query;
    const arg = {
      open_req_src: 'qysc_yyn',
      enterprise_id: id,
    };
    if (channelId) {
      arg.chaneel_id = channelId;
    } else {
      arg.chaneel_id = 0;
    }
    this.$store.dispatch('app/getQyscAdvList', arg).then((data) => {
      this.list = data;
    });
  },
};
</script>
